import { connectState, PropsFromRedux } from 'base/src/utils/reduxUtil';
import { useTranslation } from "react-i18next";

import { RootStateBase } from '../../../store/baseStore';
import { StateType } from 'domain/types/base/base'
import * as S from './styles'
import { TailSpin } from 'react-loader-spinner';
import { LoadingMessage } from '../styles';
import { Modal, ModalContent } from '../../../components/Modal';

const connector = connectState(
    (state: RootStateBase) => ({
        loading: state.BaseReducer.Loading,
    })
);

export interface LoadingProps extends PropsFromRedux<typeof connector> {
}

function MasterLoading(props: LoadingProps) {
    const { t } = useTranslation();

    const msg = props.loading && props.loading.length != 0 && props.loading[props.loading.length - 1].Message
    return (
        <Modal open={props.loading.find((e) => e.Type == StateType.Master) ? true : false}>
            <ModalContent 
                overlayStyle={{
                    opacity: 0.9, 
                    backgroundColor: 'rgba(0, 0, 0, 0.3)',
                    backdropFilter: 'blur(8px)'
                }}
                contentStyle={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '20px',
                    backgroundColor: 'transparent',
                    boxShadow: 'none'
                }}
            >
                <S.LoadingMaster>
                    <TailSpin
                        visible={true}
                        height="52"
                        width="52"
                        color="#744cb4"
                        ariaLabel="tail-spin-loading"
                        radius="0"
                        wrapperStyle={{}}
                        wrapperClass=""
                    />
                    <LoadingMessage>{msg == null ? t("Carregando") : msg}</LoadingMessage>
                </S.LoadingMaster>
            </ModalContent>
        </Modal>
    )
}

export default connector(MasterLoading);